export const GET_All_USERS = "GET_All_USERS";
export const GET_USER = "GET_USER";
export const GET_STATS = "GET_STATS";
